import { ZodError } from 'zod';

export function isErrorResponse<T extends object>(
  obj: unknown
): obj is T & { message: string } {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'message' in obj &&
    Object.keys(obj).length === 1
  );
}

export function isZodErrorResponse<T extends object>(
  obj: unknown
): obj is T & { error: ZodError } {
  const isObject = typeof obj === 'object' && obj !== null;
  const hasErrorObject = isObject && 'error' in obj && obj.error;
  const isZodError =
    hasErrorObject &&
    (obj.error instanceof ZodError ||
      (obj.error as ZodError).name === 'ZodError');
  return !!(isObject && hasErrorObject && isZodError);
}
